// Shared masking + validation helpers for the builder intake form.

export const BUILDER_EMAIL_DOMAINS = ['dreamfindershomes.com', 'coventryhomes.com'];

export const US_STATES = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' },
];

const digitsOnly = (v) => String(v ?? '').replace(/\D/g, '');

export const maskPhone = (value) => {
  const d = digitsOnly(value).slice(0, 10);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
};

export const isValidPhone = (value) => digitsOnly(value).length === 10;

export const maskZip = (value) => digitsOnly(value).slice(0, 5);

export const isValidZip = (value) => {
  const d = digitsOnly(value);
  return d.length === 5 && d !== '00000';
};

export const isZipAllZeros = (value) => {
  const d = digitsOnly(value);
  return d.length === 5 && d === '00000';
};

export const maskMoney = (value) => {
  const d = digitsOnly(value);
  if (!d) return '';
  return d.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const stripMoney = (value) => digitsOnly(value);

export const maskPercent = (value) => {
  let s = String(value ?? '').replace(/[^\d.]/g, '');
  const firstDot = s.indexOf('.');
  if (firstDot !== -1) {
    s = s.slice(0, firstDot + 1) + s.slice(firstDot + 1).replace(/\./g, '');
  }
  if (firstDot === -1) {
    s = s.slice(0, 4);
  } else {
    const intPart = s.slice(0, firstDot).slice(0, 3);
    const decPart = s.slice(firstDot + 1).slice(0, 2);
    s = decPart.length ? `${intPart}.${decPart}` : `${intPart}.`;
  }
  return s;
};

const GENERIC_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{3,}$/;

export const isValidGenericEmail = (value) => GENERIC_EMAIL_RE.test(String(value ?? '').trim());

export const isValidBuilderEmail = (value) => {
  const v = String(value ?? '').trim().toLowerCase();
  if (!GENERIC_EMAIL_RE.test(v)) return false;
  const domain = v.split('@')[1];
  return BUILDER_EMAIL_DOMAINS.includes(domain);
};
